import { controls } from "../../controls";
const rprbi28 = {
  label: "Priority Sector Loan To Weaker",
  starting: true,
  url: "Priority Sector Loan To Weaker",
  pageLabel: "Priority Sector Loan To Weaker",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "n" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI Priority Sector Loan To Weaker",
    filterable: true,
    sortable: true,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-PrioritySectorLoanToWeaker-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo: 0,
    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "Small & Marginal Farmers A/c",
        accessor: "smf_count",
      },
      {
        Header: "Small & Marginal Farmers A/c",
        accessor: "smf_amount",
      },
      {
        Header: "Scheduled Castes A/c",
        accessor: "sc_count",
      },
      {
        Header: "Scheduled Castes Amount",
        accessor: "sc_amount",
      },
      {
        Header: "Scheduled Tribes A/c",
        accessor: "st_count",
      },
      {
        Header: "Scheduled Tribes Amount",
        accessor: "st_amount",
      },
      {
        Header: "Beneficiaries of DRI Scheme A/c",
        accessor: "dri_count",
      },
      {
        Header: "Beneficiaries of DRI Scheme Amount",
        accessor: "dri_amount",
      },
      {
        Header: "SHG A/c",
        accessor: "shg_count",
      },
      {
        Header: "SHG Amount",
        accessor: "shg_amount",
      },
      {
        Header: "Women Beneficiaries A/C",
        accessor: "women_count",
      },
      {
        Header: "Women Beneficiaries Amount",
        accessor: "women",
      },
      {
        Header: "Minority Communities A/C",
        accessor: "minority_count",
      },
      {
        Header: "Minority Communities Amount",
        accessor: "minority_amount",
      },
      {
        Header: "Overdrafts A/C",
        accessor: "od_cnt",
      },
      {
        Header: "Overdrafts Amount",
        accessor: "od_amount",
      },
      {
        Header: "Other Loans to weaker section A/c",
        accessor: "other_cnt",
      },
      {
        Header: "Other Loans to weaker section Amount",
        accessor: "other_amount",
      },
    ]
  }
};
export default rprbi28;